module.exports = "pegasus/assets/theme5/twitter.png";